<template>
  <!-- 通用的页脚 author: zhangxiaofeng -->
  <div>
    <footer-fixed v-if="type === 'fixed'" ></footer-fixed>
    <footer-blocked v-else-if="type === 'blocked'"></footer-blocked>
  </div>
</template>

<script>
import FooterFixed from './FooterFixed'
import FooterBlocked from './FooterBlocked'

export default {
  name: 'FooterGeneral',
  props: {
    type: {
      type: String,
      default: 'fixed'
    }
  },
  components: {
    FooterFixed,
    FooterBlocked
  }
}
</script>
